import React, { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { initServerUrl, saveUserCache, loadUserCache } from './utils/api';
import LoginPage from './pages/LoginPage';
import MainApp from './pages/MainApp';
import './App.css';

// Fuera de Play Store no hay auto-actualización silenciosa — se avisa dentro
// de la app y el usuario toca para descargar el .apk nuevo (Android se
// encarga de preguntar si instalar encima). Solo aplica a la app Android
// (Capacitor); en web/Electron no hace nada.
function useAndroidUpdateCheck() {
  const [update, setUpdate] = useState(null);
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    (async () => {
      try {
        const info = await CapacitorApp.getInfo();
        const resp = await fetch('https://personal.asambleadepotosi.gob.bo/updates/latest-android.json');
        if (!resp.ok) return;
        const data = await resp.json();
        if (data.version && data.version !== info.version) setUpdate(data);
      } catch {}
    })();
  }, []);
  return update;
}

export default function App() {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [manualLogout, setManualLogout] = useState(false);
  const androidUpdate = useAndroidUpdateCheck();

  useEffect(() => {
    initServerUrl().then(() => {
      const saved = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      if (saved && token) setUser(JSON.parse(saved));
      setReady(true);
    });
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    saveUserCache(userData); // guardar para offline
    setManualLogout(false);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setManualLogout(true); // bloquea el auto-login hasta que el usuario ingrese manualmente
    setUser(null);
  };

  if (!ready) return (
    <div className="splash">
      <div className="splash-inner">
        <div className="splash-logo">AL</div>
        <p>Cargando...</p>
      </div>
    </div>
  );

  return (
    <>
      {androidUpdate && (
        <div className="toast-nueva-sesion" onClick={() => window.open(androidUpdate.url, '_system')}>
          🔔 Hay una actualización disponible (v{androidUpdate.version}) — tocar para descargar
        </div>
      )}
      {user
        ? <MainApp user={user} onLogout={handleLogout} />
        : <LoginPage onLogin={handleLogin} manualLogout={manualLogout} />}
    </>
  );
}
